<template>
  <div>
    <ValidationProvider :rules="rules" :vid="prefixLabel + ' ' + label" immediate v-slot="{ failed }" v-if="date">
      <md-datepicker
        :value="value"
        v-on:input="$emit('input', $event)"
        md-immediately
        :md-open-on-focus="false"
        :disabled="disabled"
        :class="{ 'md-error': failed }"
        :readonly="readonly"
        :md-model-type="String">
        <md-icon v-if="icon">{{ icon }}</md-icon>
        <label>
          {{ label }}
          <span v-if="required">&nbsp;*</span>
        </label>
      </md-datepicker>
      <span v-if="failed" class="error-msg">Please enter a valid date.</span>
    </ValidationProvider>
    <ValidationProvider :rules="rules" :vid="prefixLabel + ' ' + label" immediate v-slot="{ failed, errors }" v-else-if="email">
      <md-field :class="{ 'md-error': failed, 'md-form-group': icon, disabled, outline, dynamic }">
        <md-icon v-if="icon">{{ icon }}</md-icon>
        <label>
          {{ label }}
          <span v-if="required">&nbsp;*</span>
        </label>
        <span v-if="prefix" class="md-prefix">{{ prefix }}</span>
        <md-input :value="value" v-on:input="$emit('input', $event)" @keyup.enter="$emit('done', $event)" type="text" :disabled="disabled" :readonly="readonly"> </md-input>
        <span v-if="suffix" class="md-suffix"><small>{{ suffix }}</small></span>
        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
      </md-field>
      <span v-if="failed" class="error-msg">Please enter a correctly formatted email address.</span>
    </ValidationProvider>
    <ValidationProvider :rules="rules" :vid="prefixLabel + ' ' + label" immediate v-slot="{ failed }" v-else-if="number">
      <md-field :class="{ 'md-error': failed, 'md-form-group': icon, disabled, outline, dynamic }">
        <md-icon v-if="icon">{{ icon }}</md-icon>
        <label>
          {{ label }}
          <span v-if="required">&nbsp;*</span>
        </label>
        <span v-if="prefix" class="md-prefix">{{ prefix }}</span>
        <md-input :value="value" v-on:input="$emit('input', $event)" @keyup.enter="$emit('done', $event)" :disabled="disabled" :readonly="readonly"> </md-input>
        <span v-if="suffix" class="md-suffix"><small>{{ suffix }}</small></span>
        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
      </md-field>
      <span v-if="failed" class="error-msg">{{ errormsg }}</span>
    </ValidationProvider>
    <ValidationProvider :rules="rules" :vid="prefixLabel + ' ' + label" immediate v-slot="{ failed }" v-else-if="phone">
      <md-field :class="{ 'md-error': failed, 'md-form-group': icon, disabled, outline, dynamic }">
        <md-icon v-if="icon">{{ icon }}</md-icon>
        <label>
          {{ label }}
          <span v-if="required">&nbsp;*</span>
        </label>
        <span v-if="prefix" class="md-prefix">{{ prefix }}</span>
        <md-input :value="value" v-on:input="$emit('input', $event)" @keyup.enter="$emit('done', $event)" type="text" :disabled="disabled" :readonly="readonly"> </md-input>
        <span v-if="suffix" class="md-suffix"><small>{{ suffix }}</small></span>
        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
      </md-field>
      <span v-if="failed" class="error-msg">Please enter a valid Australian phone number.</span>
    </ValidationProvider>
    <ValidationProvider :rules="rules" :vid="prefixLabel + ' ' + label" immediate v-slot="{ failed }" v-else-if="select">
      <md-field :class="{ 'md-error': failed, 'md-form-group': icon, disabled }">
        <md-icon v-if="icon">{{ icon }}</md-icon>
        <label>
          {{ label }}
          <span v-if="required">&nbsp;*</span>
        </label>
        <md-select :value="value" v-on:input="$emit('input', $event)" type="text" :disabled="disabled" :readonly="readonly" :multiple="multiple">
          <template v-if="options">
            <md-option v-for="option of option_entries" :key="option[0]" :value="option[0]">{{ option[1] }}</md-option>
          </template>
          <template v-else>
            <slot></slot>
          </template>
        </md-select>
        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
      </md-field>
      <slot name="extraFields">
      </slot>
    </ValidationProvider>
    <ValidationProvider :rules="rules" :vid="prefixLabel + ' ' + label" immediate v-slot="{ failed }" v-else>
      <md-field :class="{ 'md-error': failed, 'md-form-group': icon, disabled, outline, dynamic }" :md-clearable="clearable">
        <md-icon v-if="icon">{{ icon }}</md-icon>
        <label>
          {{ label }}
          <span v-if="required">&nbsp;*</span>
        </label>

        <span v-if="prefix" class="md-prefix">{{ prefix }}</span>
        <md-input :value="value" v-on:input="$emit('input', $event)" @keyup.enter="$emit('done', $event)" type="text" autocomplete="url" :disabled="disabled" :readonly="readonly"> </md-input>
        <span v-if="suffix" class="md-suffix"><small>{{ suffix }}</small></span>

        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
      </md-field>
      <span v-if="failed" class="error-msg">{{ errormsg }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    options: [String, Array, Object],
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    integer: {
      type: Boolean,
      default: false,
    },
    decimals: {
      type: [Number, String],
      default: '*',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    alpha: {
      type: Boolean,
      default: false
    },
    alphaDash: {
      type: Boolean,
      default: false
    },
    alphaNum: {
      type: Boolean,
      default: false
    },
    alphaSpaces: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    defaultOption: {
      type: Boolean,
      default: false,
    },
    minValue: {
      type: [Number, String],
      default: null,
    },
    maxValue: {
      type: [Number, String],
      default: null,
    },
    digits: {
      type: [Number, String],
      default: null,
    },
    regex: {
      type: String,
      default: ""
    },
    errormsg: {
      type: String,
      default: "Please enter the correct information."
    },
    names: {
      type: String,
      default: "",
    },
    outline: {
      type: Boolean,
      default: false,
    },
    dynamic: {
      type: Boolean,
      default: false,
    },
    prefixLabel: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: 0,
    },
    date: {
      type: Boolean,
      default: false,
    },
    email: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: Boolean,
      default: false,
    },
    select: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rules(){

      let rules = [];
      if(this.required) rules.push('required');
      if(this.regex) rules.push(`regex:${this.regex}`);
      if(this.email) rules.push('email');
      if(this.integer) rules.push('integer');
      if(this.decimals) rules.push(`decimal:${this.decimals}`);
      if(this.minValue !== null) rules.push(`min_value:${this.minValue}`);
      if(this.maxValue !== null) rules.push(`max_value:${this.maxValue}`);
      if(this.digits !== null) rules.push(`digits:${this.digits}`);
      if(this.alpha) rules.push('alpha');
      if(this.alphaNum) rules.push(`alpha_num:${this.alphaNum}`);
      if(this.alphaDash) rules.push(`alpha_dash:${this.alphaDash}`);
      if(this.alphaSpaces) rules.push(`alpha_spaces:${this.alphaSpaces}`);
      if(this.names) rules.push('names');
      if(this.maxLength) rules.push(`max:${this.maxLength}`);

      return rules.join('|');
    },
    option_entries(){
      let optionValue = [];
      switch(typeof this.options){
        case 'string':
          optionValue = this.options.split(',').sort().map(i => [i,i]);
          break;
        case 'array':  return this.options.map(i => [i,i]);
        case 'object':
          if (this.options == null) {
            return {};
          } else {
            if (this.options instanceof Array) {
              optionValue = Object.values(this.options).sort().map(i => [i, i]);
              break;
            } else {
              optionValue = Object.entries(this.options).sort();
              break;
            }
          }
        default: return [];
      }
      if (this.defaultOption) {
        //add all in first index of options
        optionValue.unshift(["All","All"]);
      }
      return optionValue;
    },
    option_values(){
      return this.option_entries.map(([k,v]) => v);
    },
    items(){
      switch(typeof this.options){
        case 'string': return this.options.split(',').map(i => {return {value: i, text: i};});
        case 'array':  return this.options.map(i => {return {value: i, text: i};});
        case 'object':
          if(this.options instanceof Array){
            return Object.values(this.options).sort().map(i => {return {value: i, text: i};});
          }else{
            return Object.entries(this.options).sort().map(([i,j]) => {return {value: j, text: i};});
          }
        default: return [];
      }
    },
  },
  watch: {
  },
  data() {
    return { data: 'Weekly', };
  },

  mounted(){
    let element = this.$el.querySelector('.date-input div input');
    if (element) {
      setTimeout(function(){ element.placeholder = 'YYYY-MM-DD'; }, 100);
    }
  },
  updated(){
    let element = this.$el.querySelector('.date-input div input');
    if (element) {
      setTimeout(function(){ element.placeholder = 'YYYY-MM-DD'; }, 100);
    }
  },
};
</script>

<style lang="scss" scoped>
  .md-form-group .md-select-value{
    margin-left: 12px;
  }
  .md-field span.md-suffix{
    position: absolute;
    right: 0px;
  }
  .disabled{
    opacity: 0.7;
  }
</style>
